// App.jsx — auth shell + routes.
//   /login   public
//   /reset-password  public (link from the forgot-password email)
//   /register        public sign-up (pending until staff approve)
//   /welcome         public: one-time sign-in link from the "approved" email
//   /*       authenticated chat shell
// Phase 1 ships the auth flow + a placeholder shell; Phase 2 fills in the
// channel list, message view and composer.

import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./auth/AuthProvider.jsx";
import RequireAuth from "./auth/RequireAuth.jsx";
import Login from "./pages/Login.jsx";
import ResetPassword from "./pages/ResetPassword.jsx";
import Register from "./pages/Register.jsx";
import Welcome from "./pages/Welcome.jsx";
import Channels from "./pages/Channels.jsx";
import { lazyPanel } from "./lib/lazyPanel.jsx";
import UpdateBanner from "./components/UpdateBanner.jsx";
// The full-page meeting room (guest join links) carries WebRTC + the meeting UI — only load it on /meet/….
const Meeting = lazyPanel(() => import("./pages/Meeting.jsx"));

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/register" element={<Register />} />
        <Route path="/welcome" element={<Welcome />} />
        {/* Public: guests reach a meeting via its link and enter a display name to join. */}
        <Route path="/meet/:code" element={<Meeting />} />
        <Route path="/*" element={<RequireAuth><Channels /></RequireAuth>} />
      </Routes>
      <UpdateBanner />
    </AuthProvider>
  );
}
